import React, { Component } from 'react';

import useLocalization from '../../localization/useLocalization';
import { Wrapper, Title, Message, Icon, UserNameWrapper, Label } from './styled/UserNameStyled';

import NickName from './NickName/UserNickName';

interface UserNameProps {
    updateUsernameRequest: (nickName: string) => void;
    personalUsername: string;
    pending: boolean;
    errorCode?: string | null;
    localization: { getText: (key: string) => string };
}

class UserNameView extends Component<UserNameProps> {
    _renderNickName() {
        const { localization, personalUsername, updateUsernameRequest, pending, errorCode } = this.props;

        return (
            <UserNameWrapper>
                <Label>{localization.getText('settings.nickname.title')}</Label>
                <NickName
                    localization={localization}
                    value={personalUsername || ''}
                    pending={pending}
                    errorCode={errorCode}
                    onSave={updateUsernameRequest}
                />
            </UserNameWrapper>
        );
    }

    render() {
        const { localization } = this.props;

        return (
            <Wrapper>
                <Title>{localization.getText('settings.nickname.welcome')}!</Title>
                <Message>{localization.getText('settings.nickname.message')}</Message>
                <Icon />
                {this._renderNickName()}
            </Wrapper>
        );
    }
}

function UserName(props: Omit<UserNameProps, 'localization'>) {
    const localization = useLocalization();
    return <UserNameView {...props} localization={localization} />;
}

export default UserName;
